import { Component, input } from '@angular/core';
import { InfoIconComponent } from '../info-icon/info-icon.component';

@Component({
    selector: 'app-info-text-box',
    imports: [InfoIconComponent],
    templateUrl: './info-text-box.component.html',
    styleUrls: ['./info-text-box.component.scss']
})
export class InfoTextBoxComponent {
  readonly infoText = input.required<string>();
}
